const AddNewBooks = () => {
    return (
        <div>
            Add New Books
        </div>
    )
}

export default AddNewBooks;